<template>
  <div class="region-select-field">
    <v-select
      :value="value"
      :items="regions"
      label="Регион"
      item-text="name"
      item-value="id"
      outlined
      required
      :loading="loading || listLoading"
      :disabled="loading || disabled || listLoading"
      @change="emitInput"
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'RegionSelectField',
    data () {
      return {
        listLoading: false,
      }
    },
    props: {
      value: {
        type: Number,
        default: null,
      },
      loading: Boolean,
      disabled: Boolean,
    },
    computed: {
      ...mapGetters({
        regions: 'regions/getRegions',
      }),
    },
    methods: {
      emitInput (value) {
        console.log('--->', value, this.value)
        this.$emit('input', value)
      },
    },
    created () {
      this.listLoading = true
      this.$store.dispatch('regions/fetchRegions')
        .finally(() => {
          this.listLoading = false
        })
    },
  }
</script>

<style scoped>

</style>
